import React from 'react';
import AdminLayout from '../../../Hoc/AdminLayout';
const Dashboard = () => {
    return (
        <AdminLayout>
            <div className = "user_dashboard">
                    <h3>This is your Dashboard</h3>    
            </div>
        </AdminLayout>
     
    );
};

export default Dashboard;


// WEBPACK FOOTER //
// ./src/Components/admin/Dashboard/Dashboard.jsx